/**************************************************
 * Nombre:       Asesorate
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import negrita from "../../../Recursos/negrita.png";
import {WhatsApp} from '@mui/icons-material'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useBotonWass} from "../../../Modulo_Boton_Wass/Hooks/useBotonWass";


const Asesorate = () => {
    const {sCell, masSM} = useResponsive()
    const {abrir, Vista} = useBotonWass()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: theme.palette.primary.main}}
        >

            <Vista/>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 5}}
            >
                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-end'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{color: '#fff'}}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{fontSize: 32, fontWeight: 800, lineHeight: 1.2}}>
                                        Asesorate con nuestro equipo
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        ¿Tienes preguntas o necesitas ayuda para planificar tu próxima aventura? Nuestro
                                        equipo de expertos está aquí para ofrecerte la asesoría que necesitas y asegurar
                                        que tu experiencia sea exactamente lo que imaginas.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{fontSize: 16, fontWeight: 500}}>
                                        En Receptour, te acompañamos en cada paso
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 8}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Button
                                        onClick={(e) => abrir(e.target)}
                                        color={'secondary'} startIcon={<WhatsApp/>} sx={{px: 6}}>Hablar con un
                                        Asesor</Button>
                                </Grid>

                            </Grid>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-end', mt: sCell ? 4 : -54.5, mb: -5}}>
                            <img src={negrita} width={'90%'} height={'auto'}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Asesorate